import React from "react";
import { RouteComponentProps } from "react-router";
import styled from "styled-components";
import OutlineButton from "sweet-web/components/universal/Button/OutlineButton";
import { colors } from "sweet-web/lib/styles";

const EmptyWrapper = styled.div`
  width: 100%;
  height: ${window.innerHeight - 60}px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const PlaceholderMessage = styled.h1`
  font-size: 17px;
  font-weight: 600;
  color: ${colors.nearBlack};
  text-align: center;
  margin-bottom: 15px;
`;
type OwnProps = {};
type Props = OwnProps & RouteComponentProps;

const Dashboard: React.FC<Props> = props => {
  const emailUs = () => {
    window.open(
      `mailto:team@sweetbookings.co?subject=Dashboard%20Feedback`,
      "_blank"
    );
  };

  return (
    <EmptyWrapper>
      <PlaceholderMessage>
        We're still building the dashboard,
        <br />
        and we'd love your input
      </PlaceholderMessage>
      <OutlineButton title={"Email Us"} onClick={emailUs} link={true} />
    </EmptyWrapper>
  );
};

export default Dashboard;
